import { createContext, useContext, useEffect, useState } from "react";
import { setVerValores, ROLES_SEM_FINANCEIRO } from "@/components/pcp";
import api from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(() => {
    const raw = localStorage.getItem("pcp_user");
    return raw ? JSON.parse(raw) : null;
  });
  const [loading, setLoading] = useState(!!localStorage.getItem("pcp_token"));

  useEffect(() => { setVerValores(!!user && !ROLES_SEM_FINANCEIRO.includes(user.role)); }, [user]);
  useEffect(() => {
    const token = localStorage.getItem("pcp_token");
    if (!token) {
      setLoading(false);
      return;
    }
    api
      .get("/auth/me")
      .then((r) => {
        setUser(r.data);
        localStorage.setItem("pcp_user", JSON.stringify(r.data));
      })
      .catch(() => {
        localStorage.removeItem("pcp_token");
        localStorage.removeItem("pcp_user");
        setUser(null);
      })
      .finally(() => setLoading(false));
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("pcp_token", data.token);
    localStorage.setItem("pcp_user", JSON.stringify(data));
    setUser(data);
    return data;
  };

  const register = async (payload) => {
    const { data } = await api.post("/auth/register", payload);
    localStorage.setItem("pcp_token", data.token);
    localStorage.setItem("pcp_user", JSON.stringify(data));
    setUser(data);
    return data;
  };

  const logout = () => {
    localStorage.removeItem("pcp_token");
    localStorage.removeItem("pcp_user");
    setUser(null);
    window.location.href = "/login";
  };

  return (
    <AuthContext.Provider value={{ user, login, register, logout, loading }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
export const usePodeVerValores = () => { const { user } = useContext(AuthContext); return !!user && !ROLES_SEM_FINANCEIRO.includes(user.role); };
